<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
    :style="markStyle"
    aria-hidden="true"
  >
    <defs>
      <linearGradient :id="gradBack" x1="20%" y1="0%" x2="80%" y2="100%">
        <stop offset="0%" :stop-color="invert ? '#F0E0DC' : '#C8252C'" />
        <stop offset="100%" :stop-color="invert ? '#D6C0BC' : '#7F0F18'" />
      </linearGradient>
      <linearGradient :id="gradFront" x1="20%" y1="0%" x2="80%" y2="100%">
        <stop offset="0%" :stop-color="invert ? '#FFF4E6' : '#F25358'" />
        <stop offset="100%" :stop-color="invert ? '#F0E0DC' : '#C8252C'" />
      </linearGradient>
    </defs>
    <g v-if="showCleft" transform="translate(0, 32) scale(0.7)">
      <path :d="heartPath" :fill="`url(#${gradBack})`" />
    </g>
    <g transform="translate(60, 40) scale(0.7)">
      <path :d="heartPath" :fill="`url(#${gradFront})`" />
    </g>
  </svg>
</template>

<script>
const HEART_PATH =
  'M 100,170 C 40,130 8,100 8,58 C 8,28 32,12 56,12 C 78,12 92,28 100,46 C 108,28 122,12 144,12 C 168,12 192,28 192,58 C 192,100 160,130 100,170 Z';

export default {
  name: 'VibelaMark',
  props: {
    size: { type: Number, default: 28 },
    invert: { type: Boolean, default: false },
    showCleft: { type: Boolean, default: true },
  },
  data() {
    return {
      heartPath: HEART_PATH,
      gradBack: `vibela-mark-back-${this._uid}`,
      gradFront: `vibela-mark-front-${this._uid}`,
    };
  },
  computed: {
    markStyle() {
      const dropShadow =
        this.size >= 40 && !this.invert
          ? 'drop-shadow(0 6px 14px rgba(127,15,24,0.28))'
          : 'none';
      return { display: 'block', filter: dropShadow };
    },
  },
};
</script>
